import { render, staticRenderFns } from "./MediaThumbnail.vue?vue&type=template&id=271c7503&scoped=true&functional=true&"
var script = {}
import style0 from "./MediaThumbnail.vue?vue&type=style&index=0&id=271c7503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "271c7503",
  null
  
)

export default component.exports